// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import { Device } from '@ta/lithium.context';
import FullScreenModal from '@ta/modal.fullscreen';
import VanillaModal, { ContainerSheet, ModalBody } from '@ta/modal.vanilla';

type Props = {|
  /** Any props of the vanilla modal */
  ...React.ElementConfig<typeof VanillaModal>,
  /** When the modal should cover the entire page. Defaults to being full screen only on MW */
  fullscreen?: 'responsive' | 'always' | 'never',
|};

const Modal = ({
  fullscreen = 'responsive',
  disableAutoFocus,
  containerProps,
  header,
  bodyProps,
  enableCloseIcon = true,
  onClose,
  closeIconColor,
  children,
  ...vanillaProps
}: Props) => {
  const { viewportCategory } = React.useContext(Device);
  const isMobile = viewportCategory === 'MOBILE';
  if ((isMobile && fullscreen === 'responsive') || fullscreen === 'always') {
    return (
      <FullScreenModal
        disableAutoFocus={disableAutoFocus}
        enableCloseIcon={enableCloseIcon}
        onClose={onClose}
        closeIconColor={closeIconColor}
      >
        <ContainerSheet {...containerProps} unconstrainedHeight>
          {header}
          <ModalBody {...bodyProps}>{children}</ModalBody>
        </ContainerSheet>
      </FullScreenModal>
    );
  }
  return (
    <VanillaModal
      disableAutoFocus={disableAutoFocus}
      containerProps={containerProps}
      bodyProps={bodyProps}
      header={header}
      onClose={onClose}
      enableCloseIcon={enableCloseIcon}
      closeIconColor={closeIconColor}
      {...vanillaProps}
    >
      {children}
    </VanillaModal>
  );
};

export default Modal;
